import React from 'react';
import { Dismiss16Regular } from '@fluentui/react-icons';
import styles from './WorkspacePulse.module.css';

function toAppPath(deepLink) {
    if (!deepLink) return null;
    if (deepLink.startsWith('/')) return deepLink;
    try {
        const url = new URL(deepLink);
        return `${url.pathname}${url.search}`;
    } catch (e) {
        return null;
    }
}

function featureBadgeClass(featureType) {
    const key = String(featureType || 'Task').toLowerCase();
    if (key.includes('raid')) return styles.featureBadgeRaid;
    if (key.includes('action')) return styles.featureBadgeAction;
    if (key.includes('irl') || key.includes('information')) return styles.featureBadgeIrl;
    if (key.includes('task')) return styles.featureBadgeTask;
    return styles.featureBadgeDefault;
}

function projectDisplayName(projectOrItem) {
    return projectOrItem?.project_name_display || projectOrItem?.project_name || '';
}

function PanelItemMeta({ item }) {
    const status = item.status_display || item.status;
    const time = item.time_label;
    const assignee = item.assignee_name;

    return (
        <div className={styles.panelMetaRow}>
            <span className={featureBadgeClass(item.feature_type)}>{item.feature_type || 'Task'}</span>
            {status ? (
                <>
                    <span className={styles.panelMetaText}>·</span>
                    <span className={styles.panelMetaText}>{status}</span>
                </>
            ) : null}
            {time ? (
                <>
                    <span className={styles.panelMetaText}>·</span>
                    <span className={styles.panelMetaText}>{time}</span>
                </>
            ) : null}
            {assignee ? (
                <>
                    <span className={styles.panelMetaText}>·</span>
                    <span className={styles.panelMetaAssignee}>{assignee}</span>
                </>
            ) : null}
        </div>
    );
}

const AttentionItemsPanel = ({ open, items, total, onClose, onNavigate }) => {
    React.useEffect(() => {
        if (!open) return undefined;
        const onKeyDown = event => {
            if (event.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <>
            <div className={styles.panelOverlay} onClick={onClose} role="presentation" />
            <aside className={styles.panel} aria-label="Workspace Attention Items">
                <div className={styles.panelHeader}>
                    <div className={styles.panelHeaderText}>
                        <h2 className={styles.panelTitle}>Workspace Attention Items</h2>
                        <p className={styles.panelSubtitle}>{total} items ranked by leadership priority</p>
                    </div>
                    <button type="button" className={styles.panelClose} onClick={onClose} aria-label="Close panel">
                        <Dismiss16Regular />
                    </button>
                </div>
                <div className={styles.panelBody}>
                    {(items || []).map(item => (
                        <button
                            key={`${item.rank}-${item.item_id}-${item.title}`}
                            type="button"
                            className={styles.panelRow}
                            onClick={() => {
                                const path = toAppPath(item.deep_link);
                                if (path) onNavigate(path, item.can_open_project);
                            }}
                        >
                            <span className={styles.panelRank}>#{item.rank}</span>
                            <div className={styles.panelRowContent}>
                                <p className={styles.panelProject}>{projectDisplayName(item)}</p>
                                <p className={styles.panelIssueTitle}>{item.title}</p>
                                <PanelItemMeta item={item} />
                            </div>
                        </button>
                    ))}
                </div>
            </aside>
        </>
    );
};

export default AttentionItemsPanel;
